/**
 * PatriArt - tamanho obrigatório (v2)
 *
 * - Cor continua pré-selecionada pelo Warehouse.
 * - Tamanho aparece como "Selecione o tamanho" até escolha manual do cliente.
 * - O Warehouse pode manter uma variante interna (ex.: P) para preço/estoque,
 *   mas a compra é BLOQUEADA até uma escolha real de tamanho.
 */
(function () {
  'use strict';

  const SIZE_LABELS = ['tamanho', 'size'];
  const PLACEHOLDER = 'Selecione o tamanho';
  const ERROR_MESSAGE = 'Por favor, selecione o tamanho antes de adicionar ao carrinho.';

  // Sobrevive aos re-renders do seletor de variantes.
  const selectedSizeByForm = new Map();

  function normalize(value) {
    return (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isSizeOption(optionContainer) {
    const label = optionContainer && optionContainer.querySelector('.product-form__option-name');
    if (!label) return false;

    const optionName = normalize(label.textContent.split(':')[0]);
    return SIZE_LABELS.includes(optionName);
  }

  function getForm(formId) {
    if (!formId) return null;
    return document.getElementById(formId) || document.forms[formId] || null;
  }

  function getSizeSelectForForm(form) {
    if (!form || !form.id) return null;

    return Array.from(document.querySelectorAll('[data-patriart-size-select="true"]'))
      .find(function (select) {
        return select.dataset.patriartFormId === form.id;
      }) || null;
  }

  function markFormRequiresSize(form) {
    if (!form) return;

    form.dataset.patriartRequiresSize = 'true';

    const savedState = selectedSizeByForm.get(form.id);
    form.dataset.patriartSizeSelected = savedState && savedState.selected ? 'true' : 'false';
  }

  function clearSizeError(select) {
    if (!select) return;

    const optionContainer = select.closest('.product-form__option');
    if (!optionContainer) return;

    optionContainer.classList.remove('patriart-size-required-error');
    const existing = optionContainer.querySelector('.patriart-size-error-message');
    if (existing) existing.remove();
  }

  function clearFormError(form) {
    if (!form) return;
    const existing = form.querySelector('.patriart-size-cart-error');
    if (existing) existing.remove();
  }

  function showFormError(form) {
    if (!form) return false;

    clearFormError(form);

    const buyButtons = form.querySelector('.product-form__buy-buttons');
    const paymentContainer = form.querySelector('.product-form__payment-container');
    const anchor = buyButtons || paymentContainer;

    if (!anchor) return false;

    const message = document.createElement('div');
    message.className = 'patriart-size-cart-error';
    message.setAttribute('role', 'alert');
    message.setAttribute('aria-live', 'assertive');
    message.textContent = ERROR_MESSAGE;

    if (buyButtons) {
      buyButtons.insertBefore(message, buyButtons.firstChild);
    } else {
      paymentContainer.parentNode.insertBefore(message, paymentContainer);
    }

    message.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }

  function showSizeError(select) {
    if (!select) return;

    const optionContainer = select.closest('.product-form__option');
    if (!optionContainer) return;

    optionContainer.classList.add('patriart-size-required-error');

    let message = optionContainer.querySelector('.patriart-size-error-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'patriart-size-error-message';
      message.setAttribute('role', 'alert');
      message.textContent = ERROR_MESSAGE;
      optionContainer.appendChild(message);
    }

    optionContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });

    window.setTimeout(function () {
      try {
        select.focus({ preventScroll: true });
      } catch (error) {
        select.focus();
      }
    }, 250);
  }

  function updateDisplayedValue(optionContainer, value) {
    const displayedValue = optionContainer && optionContainer.querySelector('.product-form__selected-value');
    if (displayedValue) displayedValue.textContent = value;
  }

  function initializeSizeSelect(select) {
    if (!select || select.dataset.patriartSizeInitialized === 'true') return;

    const optionContainer = select.closest('.product-form__option');
    if (!optionContainer || !isSizeOption(optionContainer)) return;

    const formId = select.getAttribute('form') || (select.form && select.form.id);
    const form = getForm(formId);
    const optionPosition = select.getAttribute('data-option-position');
    const originalName = select.getAttribute('name');

    if (!formId || !form || !optionPosition || !originalName) return;

    const originalValue = select.value;
    const originalSelectedText = select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : '';

    markFormRequiresSize(form);

    // O Warehouse precisa continuar recebendo um valor interno de tamanho para
    // calcular variante/preço ao trocar a cor. Esse campo NÃO significa que o
    // cliente escolheu o tamanho; essa informação fica em data-patriart-size-selected.
    const proxy = document.createElement('input');
    proxy.type = 'hidden';
    proxy.name = originalName;
    proxy.value = originalValue;
    proxy.setAttribute('form', formId);
    proxy.setAttribute('data-option-position', optionPosition);
    proxy.setAttribute('data-patriart-size-proxy', 'true');

    select.removeAttribute('name');
    select.removeAttribute('data-option-position');
    select.dataset.patriartSizeInitialized = 'true';
    select.dataset.patriartSizeSelect = 'true';
    select.dataset.patriartFormId = formId;

    select.insertAdjacentElement('afterend', proxy);

    if (!select.querySelector('option[data-patriart-size-placeholder="true"]')) {
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = PLACEHOLDER;
      placeholder.disabled = true;
      placeholder.setAttribute('data-patriart-size-placeholder', 'true');
      select.insertBefore(placeholder, select.firstChild);
    }

    const savedState = selectedSizeByForm.get(formId);

    if (savedState && savedState.selected) {
      // O HTML rerenderizado pelo Warehouse já aponta para a variante correta.
      select.value = originalValue;
      proxy.value = originalValue;
      updateDisplayedValue(optionContainer, originalSelectedText);
      form.dataset.patriartSizeSelected = 'true';
    } else {
      // O valor interno pode ser P, mas visualmente o cliente ainda não escolheu.
      select.value = '';
      updateDisplayedValue(optionContainer, PLACEHOLDER);
      form.dataset.patriartSizeSelected = 'false';
    }

    select.addEventListener('change', function () {
      if (!select.value) return;

      const selectedText = select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : '';

      selectedSizeByForm.set(formId, {
        selected: true,
        value: select.value,
        label: selectedText
      });

      form.dataset.patriartRequiresSize = 'true';
      form.dataset.patriartSizeSelected = 'true';
      proxy.value = select.value;
      updateDisplayedValue(optionContainer, selectedText);
      clearSizeError(select);
      clearFormError(form);

      // Aciona o seletor nativo do Warehouse.
      proxy.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initializeAllSizeSelectors(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.product-form__option select.product-form__single-selector[data-option-position]').forEach(function (select) {
      initializeSizeSelect(select);
    });
  }

  function formNeedsSize(form) {
    if (!form) return false;

    // Esta é a trava principal e independe do valor de variante interno.
    if (form.dataset.patriartRequiresSize === 'true') {
      return form.dataset.patriartSizeSelected !== 'true';
    }

    // Fallback para o curtíssimo intervalo antes da marcação do form.
    const sizeSelect = getSizeSelectForForm(form);
    if (!sizeSelect) return false;

    const state = selectedSizeByForm.get(form.id);
    return !(state && state.selected) || !sizeSelect.value;
  }

  function blockAddToCart(event, form) {
    if (!form || !formNeedsSize(form)) return false;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    const sizeSelect = getSizeSelectForForm(form);
    showSizeError(sizeSelect);

    // Aviso redundante, mas proposital: fica imediatamente acima do botão de compra,
    // onde o cliente certamente verá mesmo que o seletor esteja fora da tela.
    const inlineShown = showFormError(form);

    // Fallback extremo para layouts/apps que movem o botão para fora do form.
    if (!sizeSelect && !inlineShown) {
      window.alert(ERROR_MESSAGE);
    }

    return true;
  }

  // Primeira barreira: captura o clique antes do componente <buy-button>.
  document.addEventListener('click', function (event) {
    const button = event.target.closest && event.target.closest('.product-form__add-button');
    if (!button) return;

    const form = button.form || button.closest('form[action*="/cart/add"]');
    blockAddToCart(event, form);
  }, true);

  // Segunda barreira para submit tradicional/integrações.
  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

    blockAddToCart(event, form);
  }, true);

  // Recebe a trava adicional colocada diretamente no BuyButton nativo do Warehouse.
  document.addEventListener('patriart:size-required', function (event) {
    const form = (event.target instanceof HTMLFormElement)
      ? event.target
      : getForm(event.detail && event.detail.formId);

    const sizeSelect = getSizeSelectForForm(form);
    showSizeError(sizeSelect);
    const inlineShown = showFormError(form);

    if (!sizeSelect && !inlineShown) {
      window.alert(ERROR_MESSAGE);
    }
  });

  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        if (node.matches && node.matches('.product-form__option select.product-form__single-selector[data-option-position]')) {
          initializeSizeSelect(node);
        }

        initializeAllSizeSelectors(node);
      }
    }
  });

  function start() {
    initializeAllSizeSelectors(document);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
